import { Trans } from "react-i18next";

import util from "utils/utils";

const ProjectAssignedManager = ({ events, ownerIdea }) => {
  return (
    <Trans
      i18nKey="notifications.projectAssignedManager"
      values={{
        name: util.getEventNames(events),
        assignee: util.getEventNames(events, "ownerAssignee"),
        idea: ownerIdea?.name || "Deleted",
      }}
    />
  );
};

export default ProjectAssignedManager;
